import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import Homescreen from './Views/HomescreenView';
import HighTea from './Views/HighTeasView';
import Shop from './Views/ShopView';
import Basket from './Views/BasketView';
import Contact from './Views/ContactView';
import LoginScreen from './Views/LoginView';
import MenuItems from './Views/MenuItemView';
import RequireAuth from "./Components/RequireAuth";

function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Homescreen />} />
          <Route path="/highteas" element={<HighTea />} />
          <Route path="/weekmenu" element={<Shop />} />
          <Route path="/winkelmandje" element={<Basket />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/gerechten" element={<RequireAuth><MenuItems /></RequireAuth>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;